/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_Complete_RegistrationInputs */



/**
* | output |
* | --- |
* | "Complete Registration" |
*
* @param {Auth_Join_Complete_RegistrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_join_complete_registration = /** @type {((inputs?: Auth_Join_Complete_RegistrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_Complete_RegistrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registrierung abschließen")
	return /** @type {LocalizedString} */ ("Complete Registration")
});